import React from "react";
import { BannerCaruselItem, BannerImageInfo } from "./BannerCaruselItem";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'

export interface BanerItemConfig {
  target: string;
  name: string;
  images: BannerImageInfo[];
}

export interface BannerCaruselProps {
  baseUrl: string;
  items: BanerItemConfig[];
  switchTime: number;
  animateStep: number;
  animateInterval: number;
  getparentHeight: () => number;
}

interface BannerCaruselState {
  currentImage: number;
  switchTimerHandle: NodeJS.Timeout | undefined;
  currentWith: number;
  currentHeight: number;
}

export class BannerCarusel extends React.Component<
  BannerCaruselProps,
  BannerCaruselState
> {
  slideRef: React.RefObject<HTMLDivElement>;
  caruselRef: React.RefObject<HTMLDivElement>;

  constructor(props: BannerCaruselProps) {
    super(props);
    this.state = {
      currentImage: 0,
      switchTimerHandle: undefined,
      currentWith: 50,
      currentHeight: 50,
    };
    this.slideRef = React.createRef();
    this.caruselRef = React.createRef();
  }

  componentDidMount() {
    this.startTimer();
    this.setSize();
  }

  startTimer() {
    let intervalId = setTimeout(() => {
      this.timerTick();
    }, this.props.switchTime);
    this.setState({ switchTimerHandle: intervalId });
  }

  stopTimer(){
    if (this.state.switchTimerHandle !== undefined)
    clearTimeout(this.state.switchTimerHandle);
  }
  componentWillUnmount() {
    
  }

  timerTick() {
    this.setSize();
    this.animationTimer();
  }

  setSize(){
    this.setState({
      currentWith: this.slideRef.current?.clientWidth ?? 0,
      currentHeight: this.props.getparentHeight(),
    });
  }

  animationTimer() {
    let basePos = this.state.currentImage * 100;
    let pos = 0;
    const stepSize = this.props.animateStep;
    let sliderRef = this.slideRef.current;
    let intervalHandle = setInterval(() => {
      pos += stepSize;
      if (pos < 100) {
        let newPos = (basePos + pos) * -1;
        let trText = "translateX(" + newPos + "%)";

        if (sliderRef instanceof HTMLElement) {
          sliderRef.style.transform = trText;
        }
      } else {
        clearInterval(intervalHandle);
        this.switchToNext();
        this.startTimer();
      }
    }, this.props.animateInterval);
  }

  switchToNext() {
    this.stopTimer();
    let nextImage = this.state.currentImage + 1;
    if (nextImage >= this.props.items.length) nextImage = 0;
    this.setState({ currentImage: nextImage });
    
  }

  switchToPrev() {
    this.stopTimer();
    let nextImage = this.state.currentImage - 1;
    if (nextImage < 0) nextImage = this.props.items.length -1;
    this.setState({ currentImage: nextImage });
  }

  render() {
    let styleContainer = `
    .bannercarusel.item{
      width: 100%;
      min-height: 100%;
      /* flex-box, center image in cell */
      display: -webkit-box;
      display: -webkit-flex;
      display:         flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
              justify-content: center;
      -webkit-align-items: center;
              align-items: center;
  }
  .bannercarusel.slider {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .bannercarusel.carusel{
    overflow-x: hidden;
    width: 100%;
    overflow-y: hidden;
    position: relative;
  }
  .bannercarusel.button{
    position: absolute;
    top:40%;
    display:none;
  }
  .bannercarusel.button.right{
    right:0px;
  }
  .bannercarusel.carusel:hover>.bannercarusel.button {
    display:block;
  }
    `;

    let translatte = "translateX(" + this.state.currentImage * -100 + "%)";

    let lastItem = this.props.items[0];
    return (
      <div className="bannercarusel carusel" ref={this.caruselRef} style={{height:this.state.currentHeight+"px"}} onMouseEnter={()=>this.stopTimer()} onMouseLeave={()=>this.startTimer()}>
        <div
          className="bannercarusel slider"
          ref={this.slideRef}
          style={{ transform: translatte}}
        >
          {this.props.items.map((value, index) => {
            return (
              <BannerCaruselItem
                key={"bci" + index}
                target={this.props.baseUrl + value.target}
                images={value.images}
                desc={value.name}
                id={index}
                needReady={
                  index === this.state.currentImage ||
                  index === this.state.currentImage + 1
                }
                currentWith={this.state.currentWith}
                imagePrefix={this.props.baseUrl}
              />
            );
          })}
          <BannerCaruselItem
            key={"bci_last"}
            target={this.props.baseUrl + lastItem.target}
            desc={lastItem.name}
            id={this.props.items.length}
            needReady={this.state.currentImage === this.props.items.length - 1}
            images={lastItem.images}
            currentWith={this.state.currentWith}
            imagePrefix={this.props.baseUrl}
          />
        </div>
        <FontAwesomeIcon className="bannercarusel button" icon={faArrowLeft} size="2x" onClick={()=>{this.switchToPrev()}}/>
        <FontAwesomeIcon className="bannercarusel button right" icon={faArrowRight} size="2x" onClick={()=>{this.switchToNext()}}/>
        
        <style scoped>{styleContainer}</style>
      </div>
    );
  }
}
